import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";
import imageCompression from "browser-image-compression";

export const fetchAllBrand = createAsyncThunk(
  "brands/fetchAllBrand",
  async (queryParams = "", { rejectWithValue }) => {
    try {
      const url = queryParams
        ? `${BASE_URL}/brand?${queryParams}`
        : `${BASE_URL}/brand`;

      const response = await axios.get(url);

      return response.data?.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return [];
      }

      return rejectWithValue(error.response?.data || "Failed to load requests");
    }
  }
);

export const AddBrand = createAsyncThunk(
  "brands/AddBrand",
  async ({ data }, { rejectWithValue }) => {
    try {
      // console.log(selectedSubCategoryId)
      // console.log("🚀 Starting AddBrand function...");

      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const formData = new FormData();

      formData.append("name_en", data.nameEn);
      formData.append("name_ar", data.nameAr);
      formData.append("area", data.selectedAreaId);
      formData.append("category", data.selectedSuperCategoryId);
      formData.append("subCategory", data.selectedSubCategoryId);

      formData.append("link", data.link);
      formData.append("desc", data.desc);

      if (data.image instanceof File) {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          fileType: "image/webp",
        };

        const compressedFile = await imageCompression(data.image, options);
        formData.append("image", compressedFile, `brand-${Date.now()}.webp`);
      }

      // console.log("🧾 Sending brand with FormData...");

      const createResponse = await axios.post(`${BASE_URL}/brand`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          token,
        },
      });

      return createResponse.data;
    } catch (error) {
      console.error("AddBrand failed:", error.message, error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to add brand");
    }
  }
);

export const deleteBrandById = createAsyncThunk(
  "brands/deleteBrandById",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.delete(`${BASE_URL}/brand/${id}`, {
        headers: {
          token: token,
        },
      });

      // console.log(" Brand deleted:", response.data);

      return id;
    } catch (error) {
      console.error("Delete failed:", error.message, error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to delete brand");
    }
  }
);

export const updateBrandById = createAsyncThunk(
  "brands/updateBrandById",
  async ({ id, data }, { rejectWithValue }) => {
    // console.log(id)
    // console.log(data)
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const formData = new FormData();
      formData.append("name_en", data.nameEn);
      formData.append("name_ar", data.nameAr);
      formData.append("link", data.link);
      formData.append("area", data.area);
      formData.append("category", data.category);
      formData.append("subCategory", data.subCategory);
      formData.append("desc", data.desc);

      if (data.image instanceof File) {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          fileType: "image/webp",
        };

        const compressedFile = await imageCompression(data.image, options);
        formData.append("image", compressedFile, `category-${Date.now()}.webp`);
      }

      const response = await axios.put(`${BASE_URL}/brand/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          token: token,
        },
      });

      return response.data.updatedBrand || response.data;
    } catch (error) {
      console.error(" Update failed:", error.message, error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to update brand");
    }
  }
);

export const updateBrandByIdForSortNumber = createAsyncThunk(
  "brands/updateBrandByIdForSortNumber",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      // console.log(id)
      // console.log(data)
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.put(`${BASE_URL}/brand/${id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          token: token,
        },
      });

      return response.data.updatedBrand || response.data;
    } catch (error) {
      console.error(" Update failed:", error.message, error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to update brand");
    }
  }
);

export const searchBrand = createAsyncThunk(
  "brands/searchBrand",
  async ({ id, keyword }, { rejectWithValue }) => {
    // console.log(id);
    try {
      const response = await axios.get(
        `${BASE_URL}/brand/search/${id}?keyword=${encodeURIComponent(keyword)}`
      );

      return response.data?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "No search results");
    }
  }
);

const brandsSlice = createSlice({
  name: "brands",
  initialState: {
    allBrands: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearBrands: (state) => {
      state.allBrands = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllBrand.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllBrand.fulfilled, (state, action) => {
        state.loading = false;
        state.allBrands = action.payload;
      })
      .addCase(fetchAllBrand.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // 🔍 search
      .addCase(searchBrand.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchBrand.fulfilled, (state, action) => {
        state.loading = false;
        state.allBrands = action.payload;
      })
      .addCase(searchBrand.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.allBrands = [];
      });
  },
});
export const { clearBrands } = brandsSlice.actions;

export default brandsSlice.reducer;
